<template>
  <div style="padding-bottom: 60px;background-color: #f0f0f0;" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="meacur_top">
      <h2>{{title}}</h2>
      <div class="meacur_tx">
        <img :src="data.headimgurl" />
        <div class="meacur_txr">
          <h3>{{data.nickname}}</h3>
          <h4>{{data.ctime}}</h4>
        </div>
      </div>
    </div>
    <div class="meacur_main"  style="margin-top: -30px;">
      <div class="mea_tb">职业健康指数</div>
      <div class="meacut_t1">
        <!-- 自我分化总体指数 -->
        <div class="overall-main">
          <div id="dashboard" class="dashboard"></div>
          <h2 class="h2">
            根据测评结果，您的职业发展健康度指数为:
            <span class="em">{{result.score}}</span>
          </h2>
        </div>
      </div>
      <div class="meacut_t1 on">
        <h3 class="chart-title">根据你的职业健康状况，为你提供的职业锦囊是：</h3>
        <div v-html="result.tips" class="mea_fov"></div>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">职业幸福感</div>
      <div
        class="mea_h2"
        style="margin-bottom: 10px;"
      >职业幸福感是指在工作中自己的需要是否能得到满足、潜能是否能得到发挥、力量是否能得以增长，并能获得持续快乐的体验，简而言之，就是工作干的“是否开心”</div>
      <div class="mea_h2" style="margin-top: 0;">下图中用五个维度的得分，反映了你当下的职业幸福感，分数越高，幸福感越高。</div>
      <div class="meacut_t1"></div>
      <div class="meacut_t1 on">
        <div class="meacur_dv clearfix">
          <h4>幸福感</h4>
          <ul class="clearfix">
            <li v-for="(item,index) in Object.keys(result.divisions[1])" :key="index" class="clearfix">
              <div :class="['dv_left',index==0?'dv_left1':'']">{{item}}</div>
              <div :class="['dv_right',index==0?'dv_right1':'',Object.keys(result.divisions[1]) && Object.keys(result.divisions[1]).length-1==index?'dv_right2':'']">
                <h2 class="sum"  :style="{width: 1.12*result.divisions[1][item] + 'rem'}"></h2>
                <dl :class="['clearfix',index==0?'dl1':'']">
                  <dt></dt>
                  <dt class="m1_dt"></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom clearfix">
            <ul>
              <li>40</li>
              <li class="b2">100</li>
              <li class="b3">评分</li>
            </ul>
          </div>
        </div>
        <div class="mea_h2">
          <h3>幸福感最高的是：<span style='color:red;'>{{result.details['1'].top.division}}</span></h3>
          <h5 clsss="small">主要表现为：</h5>
          <p v-html="result.details['1'].top.behavior"></p>
          <br/>
          <!--  -->
          <h3>幸福感最低的是：<span style='color:red;'>{{result.details['1'].bottom.division}}</span></h3>
          <h5  clsss="small">提升锦囊：</h5>
          <p v-html="result.details['1'].bottom.tips"></p>
        </div>
      </div> 
    </div>
    <div class="meacur_main">
      <div class="mea_tb">职业掌控感</div>
      <div
        class="mea_h2"
        style="margin-bottom: 10px;"
      >职业掌控度，反应的是你对自身是否能够胜任当前工作的信心程度，直接感受就是工作做得“是否顺手”。</div>
      <div class="mea_h2" style="margin-top: 0;">下图用四个维度的得分状况来反映你的职业掌控度，分数越高，掌控感越强。</div>
      <div class="meacut_t1"></div>
      <div class="meacut_t1 on">
        <div class="meacur_dv clearfix">
          <h4>掌控度</h4>
          <ul class="clearfix">
            <li v-for="(item,index) in Object.keys(result.divisions[2])" :key="index" class="clearfix">
              <div :class="['dv_left',index==0?'dv_left1':'']">{{item}}</div>
              <div :class="['dv_right',index==0?'dv_right1':'',Object.keys(result.divisions[2]) && Object.keys(result.divisions[2]).length-1==index?'dv_right2':'']">
                <h2  class="sum" :style="{width: 1.12*result.divisions[2][item] + 'rem'}"></h2>
                <dl :class="['clearfix',index==0?'dl1':'']">
                  <dt></dt>
                  <dt class="m1_dt"></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom clearfix">
            <ul>
              <li>40</li>
              <li class="b2">100</li>
              <li class="b3">评分</li>
            </ul>
          </div>
        </div>
        <div class="mea_h2">
          <h3>掌控度最高的是：<span style='color:red;'>{{result.details['2'].top.division}}</span></h3>
          <h5  clsss="small">主要表现为：</h5>
          <p v-html="result.details['2'].top.behavior"></p>
          <br/>
          <!--  -->
          <h3>掌控度最低的是：<span style='color:red;'>{{result.details['2'].bottom.division}}</span></h3>
          <h5  clsss="small">提升锦囊：</h5>
          <p v-html="result.details['2'].bottom.tips"></p>
        </div>

      </div>

    </div>
    <div class="meacur_main hb">
      <!-- <img  :src="sharing_posters?data.image_after:data.image_before" width="100%" /> -->
      <public-advertising ></public-advertising>
    </div>

    <public-ad-qrcode></public-ad-qrcode>
    
    <!--  -->
    <div class="men_foots">
      <div class="men_fr" style="width: 100%;">
        <a @click="give_share = true">分享测评给好友，获取职业健康度提升锦囊</a>
      </div>
    </div>
    <img
      class="give_share"
      alt="分享图片"
      src="@a/popse.png"
      v-show="give_share"
      @click="give_share = false"
    />
    <!-- 分享成功显示 -->
    <van-popup class="pub_alert" v-model="shareBool">
      <div class="confirm_box">
       <img src="@a/x-ceping71detail/share-scuuess.png" width="100%" />
       <a @click='toLink()' class="share-btn">点击获取锦囊</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ceping96_report } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { getStorage,  setStorage, } from "@/utils/tools";
import PublicAdvertising from "@c/measurement/public-advertising";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

import Bus from '@/utils/bus'
export default {
  data() {
    return {
      data:{},
      body_show: false,
      title: "",
      result:{},
      report: false,
      give_share: false,
      group: {},
      type_obj: {
        evaluation_id: "",
        evaluation_name: "",
        evaluation_id: "",
        nickname: ""
      },
      sharing_posters:false,
      shareBool:false
    }
  },
  components: {
    PublicAdvertising,
    PublicAdQrcode,
    PublicTopTips,
  },
  methods: {
    toLink(){
      window.location.href="https://wx662871f607e1bfa4.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjoiMiIsInJlc291cmNlX3R5cGUiOjQsInJlc291cmNlX2lkIjoibF81ZjA2ZjExNGU0YjA5YzE0MTJlM2M1ZmEiLCJhcHBfaWQiOiJhcHBUWTJHR3VVYTU3ODkiLCJwcm9kdWN0X2lkIjoiIn0";
    },
    // 广告跳转
    toViewHandle(link) {
      window.location.href = link;
    },
    // 自我分化总体指数
    dashboard_chart() {
      let myChart = echarts.init(document.getElementById("dashboard"));
      window.onresize = myChart.resize;
      let option = {
        center: ["80%", "50%"],
        series: [
          {
            type: "gauge",
            radius: "90%",
            animationDurationUpdate: 1500,
            animationEasingUpdate: "quadraticOut",
            detail: {
              textStyle: {
                fontSize: 24
              },
              offsetCenter: [0, "68%"]
            },
            splitLine: {
              //分割线样式
              length: 20
            },
            pointer: {
              length: "60%",
              width: 4
            },
            axisLine: {
              lineStyle: {
                color: [
                  [0.3, "#EF735B"],
                  [0.55, "#EEB763"],
                  [0.75, "#B4D39E"],
                  [1, "#6DABF1"]
                ],
                width: 20 // 这个是修改宽度的属性
              }
            },
            data: [
              {
                value: ""
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      myChart.setOption({
        series: [
          {
            name: "自我分化总体指数",
            type: "gauge",
            data: [{ value: this.result.score }]
          }
        ]
      });
    },
    pullData() {
      ceping96_report({
        uid: this.$route.query.uid
      }).then(data => {
        if (data.code == 10002) {
          this.$router.push({
            path:'/ceping96',
            query:this.$route.query
          });
        }else if (typeof data !== "string") {
          this.body_show = true;
          this.data = data;
          document.title = data.headtitle;
          this.title = data.headtitle;
          this.result = data.result;
          this.report = data.subscribe || !data.need_subscribe;
          // 给分享js传值
          this.type_obj.evaluation_id =  96;
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = this.$route.query.uid;
          this.type_obj.path = this.$route.path+(this.$route.query.uid?'uid='+this.$route.query.uid:'');

          shareCon("ceping96", this, this.type_obj);
          // 获取分享海报缓存
          this.sharing_posters = getStorage(this.$route.path,'sharing_posters')?true:false;

          setTimeout(()=>{
            // 第一部分
            this.dashboard_chart();
          },1000);
        } else {
          location.href = data;
        }
      });
    }
  },
  created() {
    this.pullData();
    Bus.$off('shareSuccess'); //先解绑，不然会多次出发
    Bus.$on('shareSuccess',bool=>{
      this.shareBool = bool;
      this.sharing_posters = bool;
      this.give_share =false;
      this.$forceUpdate();
    });
  }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";

</style>
<style lang="scss">
@import "@s/remChange.scss";
.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #eb5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.meacur_top {
  background: url(../../../assets/measue_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: changeRem(8.28) + px;
  padding: 0 changeRem(0.6) + px;
  padding-top: changeRem(0.65) + px;
  text-align: left;
  h2 {
    font-size: changeRem(1.08) + px;
    line-height: changeRem(1.6) + px;
    color: #fff;
    width: changeRem(8.8) + px;
    font-weight: bold;
  }
}

.meacur_tx {
  margin-top: changeRem(0.6) + px;
  img {
    border-radius: 50%;
    width: changeRem(2) + px;
    height: changeRem(2) + px;
    float: left;
  }
}

.meacur_txr {
  float: left;
  margin-left: changeRem(0.5) + px;
  h3 {
    color: #fff;
    font-size: changeRem(0.64) + px;
    line-height: changeRem(1.1) + px;
  }
  h4 {
    color: #fff;
    font-size: changeRem(0.52) + px;
    line-height: changeRem(0.7) + px;
  }
}

.meacur_main {
  width: changeRem(13.8) + px;
  background: #fff;
  border-radius: changeRem(0.16) + px;
  margin: 0 auto;
  margin-top: changeRem(0.8) + px;
  padding: changeRem(1.2) + px changeRem(0.6) + px;
  text-align: center;
}
.meacur_main.hb{
    padding:20px;
  }

.mea_tb {
  background: url(../../../assets/ma_bg.png) no-repeat top center;
  background-size: cover;
  width: changeRem(11.72) + px;
  line-height: changeRem(1.2) + px;
  height: changeRem(1.2) + px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: changeRem(0.72) + px;
  font-weight: bold;
}

.mea_h2 {
  line-height: changeRem(0.8) + px;
  color: #666;
  font-size: changeRem(0.52) + px;
  text-align: justify;
  margin: changeRem(0.8) + px 0;
  
}

.meacut_t1 {
  text-align: left;
  border-bottom: 2px dashed #ccc;
  padding-bottom:50px;
  margin-bottom:40px;
  h5{
    font-size:30px;
    margin:20px auto;
    color:#6dabf1;
  }
  .chart-title{
    font-size:28px;
    color:#eb5032;
  }
  .meacut_zk {
    width: 100%;
    margin-top: changeRem(1) + px;
    h4 {
      font-size: changeRem(0.48) + px;
      text-align: left;
      color: #333;
      line-height: changeRem(1) + px;
      width: 100%;
    }
    .zk {
      width: changeRem(11) + px;
      height: changeRem(11) + px;
      border-left: changeRem(0.04) + px solid #eb5032;
      border-bottom: changeRem(0.04) + px solid #eb5032;
      padding: changeRem(0.44) + px;
      margin-left: changeRem(0.68) + px;
      li {
        float: left;
        width: 50%;
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
    }
    .rig {
      text-align: right;
    }
  }
  .mea_vb {
    margin-top:40px;
    color: #333;
    font-weight: bold;
    text-align: justify;
    font-size: changeRem(0.52) + px;
    span {
      color: #eb5032;
    }
  }
  .mea_fov {
    margin-top: changeRem(0.3) + px;
  }
}
.meacut_t1.on{
  border-bottom:0;
  padding-bottom:0;
}

.mea_fot {
  margin-top: changeRem(0.8) + px;
  width: 100%;
}

.meacur_dv {
  width: 100%;
  position: relative;
  margin-top: changeRem(0.96) + px;
  h4 {
    color: #333;
    font-size: changeRem(0.48) + px;
    padding-left: changeRem(2.2) + px;
    padding-bottom: changeRem(0.2) + px;
  }
  .dv_top {
    position: absolute;
    right: 0;
    top: changeRem(0.08) + px;
    font-size: changeRem(0.4) + px;
    color: #333;
    line-height: 0;
    span {
      display: inline-block;
      width: changeRem(0.56) + px;
      height: changeRem(0.24) + px;
      background: rgba(238, 238, 238, 1);
      margin-right: changeRem(0.2) + px;
      vertical-align: middle;
    }
  }
  .dv_top1 {
    right: changeRem(4.2) + px;
    span {
      background-color: #6dabf1;
    }
  }
  .dv_top2 {
    right: changeRem(2) + px;
    span {
      background-color: #ef735b;
    }
  }
  .dv_left {
    float: left;
    width: changeRem(2.6) + px;
    font-size: changeRem(0.48) + px;
    text-align: right;
    padding-top: changeRem(0.1) + px;
    height: changeRem(1.76) + px;
  }
  .dv_right {
    width: changeRem(9.6) + px;
    float: right;
    border-left: 2px solid #f57f17;
    position: relative;
    height: changeRem(1.76) + px;
    h2 {
      height: changeRem(0.56) + px;
      background: #ef735b;
      position: relative;
      z-index: 1;
    }
    h2.sum {
      background-color: #6dabf1;
    }
    h2.spe {
      background-color: #eee;
    }
    dl {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      dt {
        width: changeRem(1.68) + px;
        border-right: changeRem(0.04) + px dashed #eee;
        float: left;
        height: changeRem(1.72) + px;
      }
      dt.m1_dt {
        border-right-color: #f57f17;
      }
    }
    dl.dl1 {
      top: changeRem(0.6) + px;
      dt {
        height: changeRem(2.04) + px;
      }
    }
  }
  .dv_left1 {
    height: changeRem(2.68) + px;
    padding-top: changeRem(0.92) + px;
  }
  .dv_right1 {
    height: changeRem(2.68) + px;
    padding-top: changeRem(0.92) + px;
  }
  .dv_right2 {
    border-bottom: 2px solid #f57f17;
  }
  .dv_bottom {
    width: changeRem(9.6) + px;
    float: right;
    margin-top: changeRem(0.2) + px;
    position: relative;
    li {
      margin-left: changeRem(2.96) + px;
      color: #333;
      font-size: changeRem(0.44) + px;
      text-align: center;
      float: left;
    }
    li.b2 {
      margin-left: 220px;
    }
    li.b3 {
      position: absolute;
      right: changeRem(-0.3) + px;
      bottom: 0;
    }
    li.b4 {
      margin-left: changeRem(2.65) + px;
    }
    li.b5 {
      margin-left: changeRem(2.3) + px;
    }
  }
}

img.give_share {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 750px;
  margin-left: -375px;
}
// 职业发展健康度指数
.overall-main {
  margin: 0 auto;
  border-radius: 8px;
  background-color: #fff;
  text-align: center;
  padding: 50px 0px;
  .overall-index {
    display: inline-block;
    vertical-align: bottom;
    margin: 0 auto;
    color: #333;
    font-weight: 500;
    font-size: 36px;
    line-height: 38px;
    padding: 20px;
    border-top: 4px solid #2780e0;
    border-bottom: 4px solid #2780e0;
    margin-bottom: 50px;
    position: relative;
  }
  .overall-index:after {
    content: "";
    width: 0;
    height: 0;
    border-width: 30px 30px 0;
    border-style: solid;
    border-color: #2780e0 transparent transparent;
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
  }
  // 仪表盘
  .dashboard {
    height: 400px;
    margin: 0 auto;
  }
  .h2 {
    text-align: center;
    font-size: 28px;
    line-height: 48px;
    color: #333;
    font-weight: 400;
    padding-top: 20px;
    .em {
      color: #fb5717;
      font-size: 30px;
    }
  }
  .split {
    height: 1px;
    border-bottom: 1px dashed #2780e0;
    margin: 30px auto;
  }
  .tl {
    text-align: left;
  }
  .dimension {
    margin: 0 auto;
    height: 430px;
    margin: 30px auto;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    position: relative;
  }
}
.confirm_box{
  width:630px;
  .share-btn{
    display:block;
    padding:0px 20px;
    line-height:80px;
    text-align:center;
    color:#eb5032;
    font-size:32px;
  }
}
</style>
